import { CustomerDetailsView } from '@makemydeal/dr-sales-checkin-components';

import { useCustomerDetails } from '../../hooks/useCustomerDetails';

export const CustomerDetailsSection = () => {
    const customerDetails = useCustomerDetails();

    return <CustomerDetailsView customerDetails={customerDetails} />;
};
